<template>
  <Layout footer>
    <div class="app-container text-base">
      <div class="flex items-center py-5 text-base border-b border-gray-300" style="background-color: #faf9f9">
        <span class="mr-1">当前位置：</span>
        <NBreadcrumb>
          <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
          <NBreadcrumbItem>培训管理</NBreadcrumbItem>
        </NBreadcrumb>
      </div>
      <img class="carousel-img" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/banner6.png" />
      <div class="flex items-center my-4 zhu_yi">
        <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/news.png" alt="" />
        <span class="mx-2 text-base font-bold">注意事项：</span>
        <span style="color: #f70707">
          培训平台属于培训机构后台管理功能，学员账号无访问权限，如需开通培训机构账号请联系服务人员进行开通。
        </span>
      </div>
      <img class="mt-16 mx-auto" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content6-1.png" alt="" />
      <img class="mt-16 mx-auto" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content6-2.png" alt="" />
      <img style="margin-top: 120px" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line6-1.png"
        alt="" />
      <p class="mt-10">
        为了方便培训机构管理整个培训过程，提高机构培训效率，降低培训成本，平台举措如下：
      </p>
      <div class="mt-16">
        <div class="flex">
          <img class="flex-shrink-0" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/number6-1.png"
            alt="" />
          <div class="flex-1 flex flex-col justify-end pb-3 ml-4">
            <p class="text-2xl ml-6">学员筛选智能化</p>
            <img class="mt-3" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line6.png" alt="" />
          </div>
        </div>
        <div class="text-gray-600 mt-5" style="margin-left: 80px">
          过AI技术自动筛选对比杜绝人工失误保障数据完整性，提高录入效率。
        </div>
      </div>
      <div class="flex mt-12">
        <div class="w-1/2 pr-6">
          <div class="flex">
            <img class="flex-shrink-0" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/number6-2.png"
              alt="" />
            <div class="flex-1 flex flex-col justify-end pb-3 ml-4">
              <p class="text-2xl ml-6">学员筛选智能化</p>
              <img class="mt-3" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line6c.png" alt="" />
            </div>
          </div>
          <div class="text-gray-600 mt-5" style="margin-left: 60px">
            学员基本信息利用EXCEL表格批量导入，减少培训 单位学员录入工作量，提高工作效率。
          </div>
        </div>
        <div class="w-1/2 ml-6">
          <div class="flex">
            <img class="flex-shrink-0" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/number6-3.png"
              alt="" />
            <div class="flex-1 flex flex-col justify-end pb-3 ml-4">
              <p class="text-2xl ml-6">智能化排课</p>
              <img class="mt-3" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line6c.png" alt="" />
            </div>
          </div>
          <div class="text-gray-600 mt-5" style="margin-left: 60px">
            设置好课程时间（至少45分钟）、课时数、课间时间, 自动生成相应课程安排。
          </div>
        </div>
      </div>
      <div class="flex mt-12">
        <div class="w-1/2 pr-6">
          <div class="flex">
            <img class="flex-shrink-0" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/number6-4.png"
              alt="" />
            <div class="flex-1 flex flex-col justify-end pb-3 ml-4">
              <p class="text-2xl ml-6">培训流程标准化</p>
              <img class="mt-3" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line6c.png" alt="" />
            </div>
          </div>
          <div class="text-gray-600 mt-5">
            <p style="margin-left: 60px">通过培训“三部曲”标准化了培训流程。</p>
            <div class="ml-10">
              <p>① 我要开班：新建班级、录入学员、设置课程及开班申请。</p>
              <p>② 我要开课：提醒、考勤、监管及督导等。</p>
              <p>③ 我要结业：学习、考核结业等21项档案。</p>
            </div>
          </div>
        </div>
        <div class="w-1/2 ml-6">
          <div class="flex">
            <img class="flex-shrink-0" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/number6-5.png"
              alt="" />
            <div class="flex-1 flex flex-col justify-end pb-3 ml-4">
              <p class="text-2xl ml-6">学员学情跟踪</p>
              <img class="mt-3" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line6c.png" alt="" />
            </div>
          </div>
          <div class="text-gray-600 mt-5" style="margin-left: 40px">
            通过21项报表，帮助培训机构掌握培训进度，调整培训计划。
          </div>
        </div>
      </div>
      <img class="mt-16 mx-auto" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content6-3.png" alt="" />
      <img class="mt-5 mx-auto" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content6-4.png" alt="" />
      <img style="margin-top: 50px" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line6-2.png" alt="" />
      <img style="margin-top: 50px" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content6-5.png"
        alt="" />
      <img style="margin-top: 100px" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line6-3.png"
        alt="" />
      <div class="flex" style="margin-top: 80px">
        <div class="flex">
          <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon6-1.png" alt="" />
          <div class="pl-6 pt-3">
            <p class="text-2xl" style="color: #e75306">设备</p>
            <p class="mt-2">持手机/录像机/监控。</p>
          </div>
        </div>
        <div class="flex" style="margin-left: 120px">
          <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon6-2.png" alt="" />
          <div class="pl-6 pt-3">
            <p class="text-2xl" style="color: #e75306">选择</p>
            <p class="mt-2">幵课时选择录像设备。</p>
          </div>
        </div>
      </div>
      <div class="flex mt-4">
        <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon6-3.png" alt="" />
        <div class="pl-6 pt-3">
          <p class="text-2xl" style="color: #e75306">提醒</p>
          <p class="mt-2">
            开课前20分钟开始提醒（提醒班主任打幵“智慧人才”准备录像）。如果系统未检测到开始录像每五分钟
            提醒一次，只到课程结束,成功录像结束提醒。
          </p>
        </div>
      </div>
      <div class="flex mt-4">
        <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon6-4.png" alt="" />
        <div class="pl-6 pt-3">
          <p class="text-2xl" style="color: #e75306">录像</p>
          <p class="mt-2">
            手动开启/结束，自动幵启/结束（如果在提醒期间未进行录像，每5分钟系统自动进行一次自动录像，课
            程结束后自动结束录像）。
          </p>
        </div>
      </div>
      <div class="flex mt-4">
        <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon6-5.png" alt="" />
        <div class="pl-6 pt-3">
          <p class="text-2xl" style="color: #e75306">保存</p>
          <p class="mt-2">
            如果在录像期间网络畅通，自动保存到云端。如果断网自动进行本地保存，网络畅通后上传云端。
          </p>
        </div>
      </div>
      <div class="flex mt-4">
        <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon6-5.png" alt="" />
        <div class="pl-6 pt-3">
          <p class="text-2xl" style="color: #e75306">措施</p>
          <p class="mt-2">
            闪退/断网/强制关闭/电量耗尽等情况已录制视频不丢失并通知班主任进行处理。
          </p>
        </div>
      </div>
      <img style="margin-top: 80px" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line6-4.png" alt="" />
      <img class="mx-auto" style="margin-top: 80px"
        src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content6-6.png" alt="" />
      <img class="mx-auto" style="margin-top: 100px"
        src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content6-7.png" alt="" />
    </div>
  </Layout>
</template>

<script setup>
import Layout from '@/components/Layout';
import { useRouter } from 'vue-router';

const router = useRouter();

function gotoHome () {
  router.push('/');
}
</script>

<style lang="scss" scoped>
.carousel-img {
  display: block;
  width: 100%;
  height: 410px;
  object-fit: cover;
}

:deep(.n-breadcrumb-item) {
  font-size: 16px;
}

.zhu_yi {
  border: 1px dashed #f39a1d;
  height: 60px;
  font-size: 20px;
}
</style>
